import { PainStatus } from '@constants'
import { IPaymentData } from '@query'

export const isTerminalStatus = (status: PainStatus) =>
  [
    PainStatus.ACCEPTED,
    PainStatus.REJECTED,
    PainStatus.ACCEPTED,
    PainStatus.ACCEPTED_WITH_CHANGE,
    PainStatus.ACCEPTED_PARTIALLY,
    PainStatus.REJECTED
  ].includes(status)

export const isPaymentInProgress = (payment: IPaymentData) => {
  const lastIndex = (payment?.statuses?.length || 1) - 1
  const latestStatus = payment?.statuses[lastIndex]?.status
  return latestStatus === PainStatus.IN_PROCESSING
}

export const isPaymentPending = (payment: IPaymentData) => {
  return payment?.statuses.length === 0
}

export const isPaymentRejected = (payment: IPaymentData) => {
  const lastIndex = (payment?.statuses?.length || 1) - 1
  const latestStatus = payment?.statuses[lastIndex]?.status
  return latestStatus === PainStatus.REJECTED
}
